import { Flex, Grid, SVG, Text, SVGs } from '@raskrask-dk/rr-components'
import { ReactElement } from 'react'
import { RedeemedCodeProps } from './props'
import { StyledRedeemedCode } from './styles'

export const RedeemedCode = ({
    headerText,
    redeemedCode,
    codeValueText,
    onClickUndo,
    hintText,
}: RedeemedCodeProps): ReactElement => {
    return (
        <Grid>
            <Text css={{ color: '$neutral600' }} size="s">
                {headerText}
            </Text>
            <StyledRedeemedCode>
                <Flex gap={4} alignItems="flex-end">
                    <Text bold>{redeemedCode}</Text>
                    <Text size="s">{codeValueText}</Text>
                </Flex>
                <SVG
                    css={{
                        color: '$primary600',
                        cursor: 'pointer',
                        fontSize: 20,
                        position: 'absolute',
                        right: 8,
                        top: '50%',
                        transform: 'translateY(-50%)',
                    }}
                    onClick={onClickUndo}
                    src={SVGs.CloseCircleRegular}
                />
            </StyledRedeemedCode>
            <Text css={{ color: '$neutral500' }} size="s">
                {hintText}
            </Text>
        </Grid>
    )
}
